import React from 'react';
import SideBar from "../../../../components/SideBar";
import Navbar from "../../../../components/Navbar";
import { Table } from "react-bootstrap";

const EmployeeLeaveSummary = () => {
  return (
    <>
<div className="nest-page">
        <SideBar />
        <div className="Nav">
          <Navbar
            heading="Leave Summary"
            heading_icon={<i className="fa fa-house-leave"></i>}
          />
        </div>
        <div className="container-fluid" id="skill_section">

        <div className="container-fluid">
            <h3>Leave Summary</h3>
            <div className="box-body table-responsive container-fluid px-0">
              <Table>
                <thead id="thcolor" className="text-center">
                  <tr>
                    <th>Leave Type</th>
                    <th>Leave Accrued</th>
                    <th>Leave Approved</th>
                    <th>Leave Applied</th>
                    <th>Leave Balance</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {/* {filteredLeaveDetails.map((leave, index) => (
                    <tr key={index}>
                      <td>{leave.LeaveType}</td>
                      <td>{leave.LeaveAccrued}</td>
                      <td>{leave.LeaveApproved}</td>
                      <td>{leave.LeaveApplied}</td>
                      <td>{leave.LeaveBalance}</td>
                    </tr>
                  ))} */}
                </tbody>
              </Table>
            </div>
          </div>
        </div>

        </div>
    </>
  )
}

export default EmployeeLeaveSummary